import React, { useContext, useEffect, useState } from 'react'
import Option from 'app/React/Components/Form/Option'
import getOptionPriceDescription from "app/React/Helpers/getOptionPriceDescription";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function SpecificEngineTransmissionSetting(props) {
  const {
    car,
    currentModelYear,
    currentVariant,
    isDealerConfigurator,
    lang,
    order,
    showCampaignPrice,
    strings
  } = useContext(ConfiguratorContext)

  const subDescription = car['engine_transmission_setting_title_sub_description_' + order.paymentType] ?? ''

  const [modelYearEngineTransmissions, setModelYearEngineTransmissions] = useState([])

  const [checked, setChecked] = useState(
    typeof order.configuration?.engine_transmission === 'object' ? order.configuration.engine_transmission.id : null
  )

  const option_elements = modelYearEngineTransmissions.map((engineTransmission, index) => {
    return (
      <Option
        key={index}
        option={{
          ...engineTransmission,
          description_override: getOptionPriceDescription(
            engineTransmission,
            checked,
            modelYearEngineTransmissions,
            showCampaignPrice,
            isDealerConfigurator,
            lang,
            order,
            strings
          )
        }}
        layout='standard'
        settingid='engine_transmission'
        onChange={props.onChange}
        checked={checked}
        setChecked={setChecked}
        required
        hidePrice={true}
      />
    )
  })

  useEffect(() => {
    setChecked(typeof order.configuration?.engine_transmission === 'object' ? order.configuration.engine_transmission.id : null)
  }, [order])

  useEffect(() => {
    let _modelYearEngineTransmissions = order.paymentType === 'cash' ? [...currentModelYear.cash_engine_transmissions] : [...currentModelYear.leasing_engine_transmissions]

    setModelYearEngineTransmissions(_modelYearEngineTransmissions.filter(modelYearEngineTransmission => modelYearEngineTransmission.variant_id === currentVariant.id))
  }, [currentVariant])

  if (modelYearEngineTransmissions.length < 1) {
    return null
  }

  return (
    <>
      <div className='setting variant-setting' data-setting-id='engine_transmission'>
        <h3 className='config-subtitle'>
          {strings.form.choose_engine_transmission}
        </h3>
        {
          typeof subDescription === 'string' && subDescription.length > 0 && (
            <div className='config-variant-subtitle' dangerouslySetInnerHTML={{ __html: subDescription }}/>
          )
        }
        <div className='config-radio' data-option-count={option_elements.length}>
          {option_elements}
        </div>
      </div>
      <div className='config-seperator'/>
    </>
  )
}

SpecificEngineTransmissionSetting.defaultProps = {
  onChange: null,
  className: '',
  hidePrice: false
}
